import { useCallback, useState } from 'react';

export interface ControlledAccordion {
  id: string;
  isExpanded: boolean;
  changeExpanded: (id: string) => void;
}

/**
 * Enables the controlled management of accordion lists with single and default expansion.
 */
export function useControlledAccordions(defaultOpenKey?: string) {
  const [currentExpanded, setCurrentExpanded] = useState<string | undefined>(defaultOpenKey);

  const changeExpanded = useCallback((id: string) => {
    setCurrentExpanded(key => (key === id ? undefined : id));
  }, []);

  // Returns the fields needed for a 'controlled' prop on an accordion
  const getControlledProps = useCallback(
    (key: string): ControlledAccordion => {
      return {
        id: key,
        isExpanded: currentExpanded === key,
        changeExpanded,
      };
    },
    [currentExpanded, changeExpanded],
  );

  return { currentExpanded, changeExpanded, getControlledProps };
}

export default useControlledAccordions;
